import { render, staticRenderFns } from "./TcMyAppointments.vue?vue&type=template&id=2a906502&"
import script from "./TcMyAppointments.vue?vue&type=script&lang=js&"
export * from "./TcMyAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a906502')) {
      api.createRecord('2a906502', component.options)
    } else {
      api.reload('2a906502', component.options)
    }
    module.hot.accept("./TcMyAppointments.vue?vue&type=template&id=2a906502&", function () {
      api.rerender('2a906502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcMyAppointments.vue"
export default component.exports